

/// <reference path="StockNoteProductLine.ts" />

// Generated class WarehouseInputNoteLine_ManagedObject

class WarehouseInputNoteLine_ManagedObject extends StockNoteProductLine
{
}
